module.exports = __webpack_public_path__ + "static/media/hair.556c5ea4.jpg";